import React from "react";
import { Box, Typography, Container } from "@mui/material";
import image from "../assets/mainbanner1.png";

const Scholarships = () => {
  return (
    <Container sx={{ textAlign: "center", mt: 4, px: { xs: 0, sm: 3, md: 4 } }}>
      {/* Title */}
      <Typography
        variant="h5"
        sx={{ fontWeight: "bold", mb: 2, color: "#0A1F44" }}
      >
        Scholarships
      </Typography>

      {/* Banner Section */}
      <Box
        component="img"
        src={image}
        alt="Aakash Yelahanka"
        sx={{
          width: '100%',
          height: 'auto',
          borderRadius: 3,
          boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
          transition: 'transform 0.3s ease',
          '&:hover': {
            transform: 'scale(1.02)'
          }
        }}
      />
    </Container>
  );
};

export default Scholarships;
